import { Box, styled } from '@mui/material';
import React from 'react';

// Import the mockup image
import macbookProImage from '@/assets/images/features/macbook-pro.png';

interface MacbookProMockupProps {
  screenshot?: string;
}

const MockupContainer = styled(Box)({
  position: 'relative',
  width: '100%',
  maxWidth: '600px',
  margin: '0 auto',
});

const MacbookProMockup: React.FC<MacbookProMockupProps> = ({ screenshot }) => (
  <MockupContainer>
    <Box
      component="img"
      src={macbookProImage}
      alt="Macbook Pro Mockup"
      sx={{
        width: '100%',
        height: 'auto',
        objectFit: 'contain',
      }}
    />
    {screenshot && (
      <Box
        component="img"
        src={screenshot}
        alt="Application Screenshot"
        sx={{
          position: 'absolute',
          top: '2.8%',
          left: '9.3%',
          width: '82.4%',
          height: '88.6%',
          objectFit: 'cover',
          borderRadius: '2px',
        }}
      />
    )}
  </MockupContainer>
);

export default MacbookProMockup;
